import React, { useEffect, forwardRef, useRef,useContext, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { NavLink, useHistory } from 'react-router-dom';
import MaterialTable from 'material-table';
import { TablePagination, CircularProgress } from '@material-ui/core';
import { MoreVertRounded } from '@material-ui/icons';
import API_PATH from "../../constants/config.json";
import { clearCookie, getPrivileges } from '../../functions/Auth';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Cookies from 'js-cookie';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { withStyles } from "@material-ui/core/styles";
import TableIcons from '../TableIcons';
import MapContext from '../../context/MapContext'
import CloseIcon from '@material-ui/icons/Close';

import IntStationCard from '../StationDetails/Intersection/StationCard';
import MidStationCard from '../StationDetails/Midblock/StationCard';
import moment from 'moment'

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

function StyledCheckbox(props) {
  const classes = useStyles();

  return (
    <Checkbox
      className={classes.rootC}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ 'aria-label': 'decorative checkbox' }}
      {...props}
    />
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: '0px',
    bottom: '5px',
    height: '77vh',
    '@media only screen and (max-height: 820px)': {
      height: '70vh'
    },
    '@media only screen and (max-width: 3500px)': {
      width: '482px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '882px',
    },
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '150px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
  },
  searchMainBlock: {
    padding: '10px',
    position: 'fixed',        
    float: 'right',
    background: '#fff',
    border: '1px solid #24618E',
    //borderRadius: '5px',
    borderRadius: '0px 5px 5px 0px',
    borderLeft: '0px',
    bottom: '5px',
    //left: '-2px',
    zIndex: '22',
    height: '94.8vh', 
    width: '505px',
    '@media only screen and (max-height: 820px)': {
      height: '83vh'
    },
    '@media only screen and (min-width: 3501px)': {
      '& .MuiSelect-select':{
        fontSize:'22pt',
      },
      '& .MuiTypography-caption':{
        fontSize:'22pt',
      }
    }, 
    // marginBottom: '60px',
    '& h4': {      
      margin: '0',
      color: '#333',
      marginBottom: '5px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '16pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '25pt',
      }, 
    },
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      padding: '0',
    },
    '& .MuiBox-root': {      
      height: '71vh',
      '@media only screen and (max-height: 820px)': {
        height: '62vh'
      }, 
    },
    '& th.MuiTableCell-root.MuiTableCell-head': {
      display: 'none',
    },
    '& .MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded': {
      position: 'unset !important',
    },
    '& .MuiToolbar-regular': {
      minHeight: '0px',
    },
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
  }, tabblock: {
    border: '1px solid #24618E',
    paddingTop: '10px',
    marginBottom: '0px',
    borderRadius: '0px 5px 5px 5px',
    width: '100%',
    float: 'left',
    '& .MuiBox-root': {
      padding: '0px 10px 10px 10px',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    }
  },
  closeIcon: {
    textAlign: 'right',
    margin: '0',
    position: 'absolute',
    top: '10px',
    cursor: 'pointer',
    color: '#24618E',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20pt',
      right: '10px',
      width: '40px'
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
      right: '15px',
      width: '60px',
    },
    '&:hover': {
      color: '#CC0000',
    }
  },
  stationDeatilsBlock: {
   
    '& ul': {
      padding: '0',
      margin: '0',
    },
    '& li': {
      display: 'inline-block',
      textAlign: 'center',
      padding: '0 5px',
      '& svg': {
        verticalAlign: 'middle',
        color: '#24618E',
      }
    },
    '& p': {
      marginTop: 0,
      marginBottom: '5px',
      color: '#24618E',
      '& .checkBoxes': {
        padding: '0',
        verticalAlign: 'middle',
        paddingRight: '5px',
        position: 'relative',
        top: '-2px',
      }
    },
  },
  expoSelected: {
    background: '#fff',
    color: '#333',
    border: '1px solid #333',
    marginTop: '5px',
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
      background: '#fff',
    }
  },
  myCheckBox: {
    padding: '0',
    verticalAlign: 'middle',
    paddingRight: '5px',
    position: 'relative',
    top: '-2px',
    paddingLeft: '11px',
  }, tabRoot: {

  },
  headerDiv: {
    width: '100%',
    float: 'left',
    '& .MuiSvgIcon-root': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt'
      },
    },
    '& .headerDiv-left': {
      width: '60%',
      float: 'left',
    },
    '& .headerDiv-right': {
      width: '40%',
      float: 'right', tabRoot: {

      },
      textAlign: 'right',
    }
  },
  swipe: {
    '& div:first-child': {
      // overflow: 'hidden !important',
    },
    '& .MuiToolbar-root.MuiToolbar-regular': {
      '@media only screen and (max-width: 3500px)': {
        height: '50px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '60px',
      },
    },
    '& .MuiPaper-root.MuiPaper-elevation2.MuiPaper-rounded div:nth-child(2)': {
      marginTop: '-45px',
      height: '57vh',
      '@media only screen and (max-height: 820px)': {
        height: '45vh'
      },
    }
  },
  loader: {
    '& .MuiCircularProgress-root': {
      color: '#24618E !important',
      marginLeft: '50% !important',
      marginTop: '50% !important'
    }
  },
  panelDivLeft: {
    float: 'left',
    marginLeft: '-10px',
    marginTop: '-10px',
    '@media only screen and (max-width: 3500px)': {
      width: '7%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '5%',
    },
    '& .MuiSvgIcon-root': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt'
      },
    }

  },
  panelDivRight: {
    float: 'right',
    height: 'auto !important',
    marginTop: '0 !important',
    '@media only screen and (max-width: 3500px)': {
      width: '93%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '95%',
    },
  },
  searchDiv: {

  },
  totalResults: {
    margin: '0 0 3px'
  },
  tableHeader: {
    overflow: 'hidden',
    width: '100%',
    padding: '16px 16px 0',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },
  resultsLbl: {
    fontSize: '14px',
    fontFamily: 'Inter-Medium !important',
    color: '#71717A !important',
   
    
    float: 'left'
  },
  exportIcon: {
    float: 'right',
    color: '#71717A',
    cursor: 'pointer'
  },
  exportOptsList: {
    position: 'absolute',
    right: '6px',
    top: '50px',
    width: '232px',
    backgroundColor: '#ffffff',
    boxShadow: '0px 10px 15px -3px rgb(0 0 0 / 10%), 0px 4px 6px -2px rgb(0 0 0 / 5%)',
    borderRadius: '6px',
    '& ul': {
      listStyle: 'none',
      paddingLeft: '0',
      margin: '4px 0',
     
      '& li:not(.divisor)': {
        padding: '8px 20px',
        cursor: 'pointer',
        display: 'flex',
        '& span': {
          fontSize: '14px',
          fontFamily: 'Inter-Regular !important',
          lineHeight: '20px',
          color: '#3F3F46',
        },
        '& img': {
          opacity: '0.4',
          marginRight: '12px',
          verticalAlign: 'middle'
        },
        '&:hover': {
          backgroundColor: '#f4f4f5',
          '& span': {
            color: '#18181b'
          },
          '& img': {
            opacity: '0.5'
          }
        }
      },
      '& li.divisor': {
        borderBottom: '1px solid #f4f4f5',
        margin: '4px 0'
      },
    }
  },
  rootChk: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#ffffff',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#2563EB',
    boxShadow: 'none',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#2563EB',
    },
  },
}));
//End Css code ...

let countChecked = 0;

//Start SearchResults component code ...
const SearchResults = props => {
  const classes = useStyles();
  let history = useHistory();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [midblockData, setmidBlockData] = React.useState([]);
  
  const [intersectionData, setIntersectionData] = React.useState([]);
  const [pageNoMidblock, setPageNoMidblock] = React.useState(0);
  const [pageSizeMidblock, setPageSizeMidblock] = React.useState(25);
  const [dataFromMidblock, setDataFromMidblock] = React.useState(1);
  const [dataToMidblock, setDataToMidblock] = React.useState(pageSizeMidblock);

  const [pageNoIntersection, setPageNoIntersection] = React.useState(0);
  const [pageSizeIntersection, setPageSizeIntersection] = React.useState(25);
  const [dataFromIntersection, setDataFromIntersection] = React.useState(1);
  const [dataToIntersection, setDataToIntersection] = React.useState(pageSizeIntersection);

  const [allIntersectionCheck, setAllIntersectionCheck] = React.useState(false);
  const [allMidblockCheck, setAllMidblockCheck] = React.useState(false);

  const [loader, setLoader] = React.useState(false);
  const prevDataRef = React.useRef();
  const prevSearhcRef = React.useRef();
  const prevData = prevDataRef.current;
  const prevSearch = prevSearhcRef.current;

  const [resultData, setResultData] = React.useState([]);
  const [allStationCheck, setAllStationCheck] = React.useState(false);
  
  const [pageNoResult, setPageNoResult] = React.useState(0);
  const [pageSizeResult, setPageSizeResult] = React.useState(25);
  const [dataFromResult, setDataFromResult] = React.useState(1);
  const [dataToResult, setDataToResult] = React.useState(pageSizeMidblock);
  const [showExportOpts, setShowExportOpts] = React.useState(false);
  const [showExportPanel, setShowExportPanel] = React.useState(false);

  const [scrolled, setScrolled] = React.useState(false);
  const stationListRef = useRef();
  const stationListHeaderRef = useRef();
  const [maxFileNum, setMaxFileNum] = React.useState(50);

  const [searchResultsActive, setSearchResultsActive] = useState(false);
  const [startDtFormat, setStartDtFormat] = useState(null);
  const [endDtFormat, setEndDtFormat] = useState(null);
  const [initialHeight, setInitialHeight] = useState(116);

  const {filter, setFilter, clearFilterYear}=useContext(MapContext);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  useEffect(
    () => {
      if (props.selectedStationType == 1) {
        setValue(1);
      } else if (props.selectedStationType == 2) {
        setValue(0);
      }
      prevDataRef.current = props.resultData;
      prevSearhcRef.current = props.searchParam;
      if(props.showSearchWidgetResult){
        if (props.resultData !== prevData) {
          getYearsData(props.resultData);
        }
      }else{
        getYearsDatav2(props.resultDatav2);
      }

      if(filter.volume || filter.class || filter.speed || filter.bicycle || filter.pedestrian || filter.turn || filter.endDate !== "" || filter.storageFileFilterActive) {
        setSearchResultsActive(true);
        if(filter.startDate !== "") {
          let dt = new moment(filter.startDate).toDate();
          let tmpstr = monthNames[dt.getMonth()]+" "+dt.getFullYear();
          setStartDtFormat(tmpstr);
        }
        if(filter.endDate !== "") {
          let dt = new Date(filter.endDate);
          let tmpstr = monthNames[dt.getMonth()]+" "+dt.getFullYear();
          setEndDtFormat(tmpstr);
        }
        if(stationListHeaderRef && stationListHeaderRef.current){
          let tmp = stationListHeaderRef.current.clientHeight + 45;
          setInitialHeight(tmp);
        }
      } else {
        setSearchResultsActive(false);
        setInitialHeight(116);
      }
      
    
    }, [props.resultData, props.selectedStationType,props.resultDatav2, props.showSearchWidgetResult, filter]
  );
  useEffect(()=>{
    getFileLimit();
  },[])

  const getFileLimit = () => {
    
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getExportFileLimit,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            if (response.data && response.data.data) {
              let data = response.data.data;
              data.forEach(function(item) {
                if(item.type === "export_file")
                  setMaxFileNum(item.max);
              })
            } 
          }
        }).catch(async function (error) {
          if (error.response) {
            if (error.response.status && error.response.status == '401') {
              if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
              }
              history.push('/');
            }
          }
        })
    } catch (error) {
      console.error(error);
    }
  }


  const handleScroll = () => {
    if (stationListRef.current) {
      const { scrollTop } = stationListRef.current;
      if (scrollTop > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
};

//this method select all stations from the list to export

  const selectAllStations = (e) => {
    setAllStationCheck((prev) => !prev);
    let stationArr = resultData;
   
    props.allStations(e.target.checked, 'station', stationArr, maxFileNum);
    
    if(e.target.checked) {
      let counter = 0;
      stationArr.forEach(function(item, ind) {
        if(counter < maxFileNum) {
          if(item.station_type === 1 && (item.volumeyear !== "" || item.classyear !== "" || item.speedyear !== "")) {
            counter++;
            stationArr[ind]['checked'] = true;
          } else if (item.station_type === 2 && (item.turningyear !== "" || item.bicycleyear !== "" || item.pedestrianyear !== "")) {
            counter++;
            stationArr[ind]['checked'] = true;
          }
        }
      });
      setResultData(stationArr);
      countChecked = counter;
    } else {
      setResultData(stationArr.map(item => ({ ...item, checked: false })));
      countChecked = 0;
    }
   
  }

  //this method export one station from the list to export

  const selectOneStation = async (e, station_type, client_Station_Id, Station_location) => {
    let stationArr = resultData;
    // verify how many files are already checked
    let counter = 0;
    stationArr.forEach(function(item, ind) {
      if(item.checked) {
        counter++;
      }
    });
    if (e.target.checked == true) {
      if(counter < maxFileNum) {
        setResultData(stationArr.map(item => (item.station_id == e.target.value ? { ...item, checked: true } : item)));
        props.groupStations(e.target.checked, parseInt(e.target.value), station_type, client_Station_Id, Station_location);
        countChecked += 1;
      }
    }
    else {
      setAllStationCheck(false);
      setResultData(stationArr.map(item => (item.station_id == e.target.value ? { ...item, checked: false } : item)));
      props.groupStations(e.target.checked, parseInt(e.target.value), station_type, client_Station_Id, Station_location);
      countChecked -= 1;
    }
  }

  //This method is use for API call to get years Data .... Start
  const getYearsData = async (data) => {
    setLoader(true);
    let yearData = data;
    let body = data.map((value) => {
      return {
        "station_id": value.station_id,
        "station_type": value.station_type == 1 ? "Midblock" : "Intersection"
      }
    })
    try {
      await axios({
        method: 'post',
        url: API_URL + API_PATH.getStationlistwithyear,
        data: body
      })
        .then(async function (response) {
          if (response && response.data.data) {
            let dataTemp = response.data.data;
            yearData.map((item, index) => item.station_id == dataTemp[index].station_id ? (item.class = dataTemp[index].class, item.speed = dataTemp[index].speed, item.volume = dataTemp[index].volume, item.bicycle = dataTemp[index].bicycle, item.pedestrian = dataTemp[index].pedestrian, item.volume = dataTemp[index].volume, item.turning = dataTemp[index].turning) : item);
          }
          setLoader(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoader(false);
        })
    } catch (error) {
      console.error(error);
      setLoader(false);
    }

    let tempMidblockArr = [];
    let tempResultArr = [];
    let tempIntersectionArr = [];
    yearData && yearData.filter((value, index) => {
      value.checked=false;
      if (value.station_type == 1) {
        tempMidblockArr.push(value);
        tempResultArr.push(value);
      } else {
        tempIntersectionArr.push(value);
        tempResultArr.push(value);
      }
    });
    if (tempIntersectionArr.length == 0) setValue(1);
    if (pageSizeIntersection >= tempIntersectionArr.length) {
      setDataToIntersection(tempIntersectionArr.length);
    } else {
      setDataToIntersection(pageSizeIntersection)
    }
    if (pageSizeMidblock >= tempMidblockArr.length) {
      setDataToMidblock(tempMidblockArr.length);
    } else {
      setDataToMidblock(pageSizeMidblock)
    }

    if (pageSizeResult >= tempResultArr.length) {
        setDataToResult(tempResultArr.length);
      } else {
        setDataToResult(pageSizeResult)
      }

    setmidBlockData(tempMidblockArr);
    setIntersectionData(tempIntersectionArr);
    let tmp;
    if(props.toggleScenariosLayer) {
      tmp = tempResultArr.filter(station => (!station.is_shared))
    } else  {
      tmp = tempResultArr.filter(station => (!station.is_shared || (station.is_shared && station.visible)))
    }
    setResultData(tmp)
  }

  //This method is use for API call to get years Data .... Start
  const getYearsDatav2 = async (data) => {
    
    let body=[]

    body = data.map((value) => {
      return value.attributes
    })
    let tempResultArr = body.map((value) => {
      
      //validarstudies an year
      value.checked=false;
      if (value.station_type==1){
        //midblockData
        value.class=""
        value.speed=""
        value.volume=""
        if( value.max_typemid!=null && value.max_typemid.includes('v') ) {
          value.volume=value.max_mid_year
        }
        if( value.max_typemid!=null && value.max_typemid.includes('s')) {
          value.speed=value.max_mid_year
        }
        if(value.max_typemid!=null && value.max_typemid.includes('c')) {
          value.class=value.max_mid_year
        }

      }else{
        //ìntersection
        value.pedestrian=""
        value.bicycle=""
        value.turning=""
        if( value.max_typeint!=null && value.max_typeint.includes("p")) {
          value.pedestrian=value.max_int_year
        }
        if( value.max_typeint!=null && value.max_typeint.includes("b")) {
          value.bicycle=value.max_int_year
        }
        if(value.max_typeint!=null && value.max_typeint.includes("m")) {
          value.turning=value.max_int_year
        }

      }
      
      value.location=value.station_location
      return value
    })
    
    if (pageSizeResult >= tempResultArr.length) {
        setDataToResult(tempResultArr.length);
      } else {
        setDataToResult(pageSizeResult)
      }
      // filtering shared stations
      let tmp;
      if(props.toggleScenariosLayer) {
        tmp = tempResultArr.filter(station => (!station.is_shared))
      } else  {
        tmp = tempResultArr.filter(station => (!station.is_shared || (station.is_shared && station.visible)))
      }
      setResultData(tmp);

  }
  //This method is use for API call to get years Data .... End

  const handleExportOptions = () => {
    setShowExportOpts(true);
  }

  const handleClickAway = () => {
    setShowExportOpts(false);
  }

  const handleExportSelect = () => {
    setShowExportPanel(true);
    setShowExportOpts(false)
    props.handleActiveExportFiles(true);
  }

  const handleCancelExport = () => {
    setShowExportPanel(false); 
    props.handleActiveExportFiles(false);
    setAllStationCheck(false);
    let stationArr = resultData;
    props.allStations(false, 'station', stationArr, maxFileNum);
    setResultData(stationArr.map(item => ({ ...item, checked: false })));
    props.handleClearExport();
    countChecked = 0;
  }
  const handleClickStationDetails = (rowData) => {   
    props.getStationDetail(rowData.station_id); 
    props.highlightStation(rowData.latitude, rowData.longitude, rowData.station_id, rowData.station_type,rowData.visible,rowData.is_shared)  
  }
  const handleClickStationExport = (e,rowData) => {    
    selectOneStation(e, rowData.station_type, rowData.client_station_id, rowData.location)
  }

  const removingFilters = (type) => {
    switch(type) {
      case 'volume':
        setFilter({...filter,
          volume:false
        });
        break;
      case 'speed':
        setFilter({...filter,
          speed:false
        });
        break;
      case 'class':
        setFilter({...filter,
          class:false
        });
        break;
      case 'bicycle':
        setFilter({...filter,
          bicycle:false
        });
        break;
      case 'turn':
        setFilter({...filter,
          turn:false
        });
        break;
      case 'pedestrian':
        setFilter({...filter,
          pedestrian:false
        });
        break;
      case 'date':
        setFilter({...filter,
          endDate:"",
          startDate: ""
        });
        clearFilterYear()
        break;
      case 'signal':
        setFilter({
          ...filter,
          intersection_type: {
            ...filter.intersection_type,
            signal: false
          }
        });
        break;
      case 'stop':
        setFilter({
          ...filter,
          intersection_type: {
            ...filter.intersection_type,
            stop: false
          }
        });
        break;
      case 'roundabout':
        setFilter({
          ...filter,
          intersection_type: {
            ...filter.intersection_type,
            roundabout: false
          }
        });
        break;
      case 'unknown':
        setFilter({
          ...filter,
          intersection_type: {
            ...filter.intersection_type,
            unknown: false
          }
        });
        break;
    }
  }
  return (
    <React.Fragment>
      <div className={'panel-result'}>
       
        
        {
              loader == false ? resultData.length > 0 ?
                <>
                 <div className={ scrolled ? classes.tableHeader+" panel-scrolled" : classes.tableHeader} ref={stationListHeaderRef}>
                   <div className={'main-panel-result'} >
                    <div className={'results-title-lbl'}> 
                      <label className='station-list-lbl'>{ (props.searchParam && props.searchParam !== ""  && !showExportPanel) || (searchResultsActive && !showExportPanel) ? "Search results" :  ((showExportPanel && searchResultsActive) || showExportPanel) ? "Data export" : "Station list"}</label>
                      <label>{resultData.length} results {props.searchParam && props.searchParam !== "" ? `for ` : ""}{props.searchParam && props.searchParam !== "" ? <span>"{props.searchParam}"</span> : ""}
                      {props.polygonDrawn ? <span> in selected area</span> : ""}
                      </label>
                    </div>
                    {
                      getPrivileges().length > 0 ?
                        <MoreVertRounded onClick={handleExportOptions} className={classes.exportIcon} />
                        :
                        null
                    }
                   </div>
                   <div className='active-filters'>
                        {filter.volume && <label className='green-filter' onClick={() => removingFilters('volume')}>Volume count <CloseIcon /> </label>}
                        {filter.class && <label className='green-filter' onClick={() => removingFilters('class')}>Vehicle class <CloseIcon /></label>}
                        {filter.speed && <label className='green-filter' onClick={() => removingFilters('speed')}>Vehicle speed <CloseIcon /></label>}
                        {filter.bicycle && <label className='blue-filter' onClick={() => removingFilters('bicycle')}>Bicycle count <CloseIcon /></label>}
                        {filter.turn && <label className='blue-filter' onClick={() => removingFilters('turn')}>Turning count <CloseIcon /></label>}
                        {filter.pedestrian && <label className='blue-filter' onClick={() => removingFilters('pedestrian')}>Pedestrian count <CloseIcon /></label>}
                        {filter.intersection_type.signal && <label className='blue-filter' onClick={() => removingFilters('signal')}>Signal <CloseIcon /></label>}
                        {filter.intersection_type.stop && <label className='blue-filter' onClick={() => removingFilters('stop')}>Stop <CloseIcon /></label>}
                        {filter.intersection_type.roundabout && <label className='blue-filter' onClick={() => removingFilters('roundabout')}>Roundabout <CloseIcon /></label>}
                        {filter.intersection_type.unknown && <label className='blue-filter' onClick={() => removingFilters('unknown')}>unknown <CloseIcon /></label>}
                        {filter.endDate !== "" && <label className='amber-filter' onClick={() => removingFilters('date')}>{startDtFormat} - {endDtFormat} <CloseIcon /></label>}
                    </div>
                   {showExportPanel ?
                    <>
                        <div className={'export-panel-options '}>
                            <StyledCheckbox 
                              checked={allStationCheck}
                              onChange={(e) => selectAllStations(e)}
                              indeterminate={countChecked > 0 && !allStationCheck}
                            />
                            {getPrivileges().length > 0 ?
                                <Button 
                                  className={ ' btn-export bg-blue-600 txt-gray-white margin-r-16'}  
                                  id="export_selected"  
                                  onClick={props.checkExportValue} 
                                  disabled={countChecked === 0}
                                >
                                    Export selection
                                </Button> 
                                  
                              : null
                            }
                          <Button className={ 'btn-cancel bg-gray-white txt-gray-700'} 
                            onClick={handleCancelExport}> Cancel</Button>
                        </div>
                        <div className="max-selection-stations">
                          <label>Max selection {maxFileNum} stations:</label>
                          <label className={(maxFileNum-countChecked) === 0 ? 'no-left' : null}>{maxFileNum-countChecked} stations left</label>
                        </div>
                      </>
                      :
                      null
                  }
                  </div>
                </>
              : <div  >
                    <div className='' style={{ width: '100%' }}>
                      <div className={'no-result-content'}>
                        <div className={'main-panel-result'} >
                          <div className={'results-title-lbl'}>
                            <label className='station-list-lbl'>{(props.searchParam && props.searchParam !== "") || searchResultsActive ? "Search results" : "Station list"}</label>
                            <label>{resultData.length} results {props.searchParam && props.searchParam !== "" ? `for ` : ""}{props.searchParam && props.searchParam !== "" ? <span>"{props.searchParam}"</span> : ""}</label>
                          </div>
                        </div>
                        <div className='active-filters'>
                          {filter.volume && <label className='green-filter' onClick={() => removingFilters('volume')}>Volume count <CloseIcon /> </label>}
                          {filter.class && <label className='green-filter' onClick={() => removingFilters('class')}>Vehicle class <CloseIcon /></label>}
                          {filter.speed && <label className='green-filter' onClick={() => removingFilters('speed')}>Vehicle speed <CloseIcon /></label>}
                          {filter.bicycle && <label className='blue-filter' onClick={() => removingFilters('bicycle')}>Bicycle count <CloseIcon /></label>}
                          {filter.turn && <label className='blue-filter' onClick={() => removingFilters('turn')}>Turning count <CloseIcon /></label>}
                          {filter.pedestrian && <label className='blue-filter' onClick={() => removingFilters('pedestrian')}>Pedestrian count <CloseIcon /></label>}
                          {filter.endDate !== "" && <label className='amber-filter' onClick={() => removingFilters('date')}>{startDtFormat} - {endDtFormat} <CloseIcon /></label>}
                        </div>
                        <div className={'no-result-box'}>
                            <div className={'no-result-img'}>
                              <img src={require('../../assets/icons/Location - Pin.svg')}   />
                              </div>
                              <div className={'no-result-title'}>
                                No results
                              </div>
                              <div className={'no-result-desc'}>
                              There are no results in this area of the map.
                                Move your view to find more stations.
                              </div>

                            </div>
                      </div>
                    </div>
                  </div> : null
              }
              {
                loader == false ?
                  <div className={showExportPanel ?'rp-table-container-export':'rp-table-container'} onScroll={handleScroll} ref={stationListRef} style={{  height: 'calc(100vh - '+initialHeight+'px)' }} >
                    
                    <div className={'rp-table-container-child'}>
                        <MaterialTable
                          icons={TableIcons}
                          title=""
                          cellStyle={{padding:'5px 10px'}}
                          headerStyle={{display:'none'}}
                          columns={[
                            {
                              render : function(rowData){   
                                if(rowData.station_type==2){                                  
                                  return <IntStationCard 
                                    
                                    sharedStation={rowData.is_shared} 
                                    sharedAgencyName={rowData.agency} 
                                    stationData={rowData} 
                                    turningCountDate={(rowData.turningyear &&  rowData.turningyear!='' )?rowData.turningyear.split('-')[0]:''} 
                                    pedestrianCountDate={(rowData.pedestrianyear && rowData.pedestrianyear!='')?rowData.pedestrianyear.split('-')[0]:''} 
                                    biCycleCountDate={(rowData.bicycleyear && rowData.bicycleyear!='')?rowData.bicycleyear.split('-')[0]:''}
                                    fnDetails={handleClickStationDetails} 
                                    export={showExportPanel}
                                    fnExport={handleClickStationExport}
                                    cardOver={props.cardOver}
                                    cardOut={props.cardOut}
                                    toggleScenarios={props.toggleScenariosLayer}
                                    toggleMarkerBasedOnCapacityLayer={props.toggleMarkerBasedOnCapacityLayer}
                                    toggleMarkerCapacitySelected={props.toggleMarkerCapacitySelected}
                                    toggleMarkerBasedOnLaneGeometryLayer={props.toggleMarkerBasedOnLaneGeometryLayer}
                                  />
                                }else{
                                  return <MidStationCard 
                                  
                                    sharedStation={rowData.is_shared} 
                                    sharedAgencyName={rowData.agency} 
                                    stationData={rowData} 
                                    volumeCountDate={(rowData.volumeyear && rowData.volumeyear!='')?rowData.volumeyear.split('-')[0]:''} 
                                    volumeClassCountDate={(rowData.classyear && rowData.classyear!='')?rowData.classyear.split('-')[0]:''} 
                                    traffiSpeedCountDate={(rowData.speedyear && rowData.speedyear!='')?rowData.speedyear.split('-')[0]:''}
                                    fnDetails={handleClickStationDetails} 
                                    export={showExportPanel}
                                    fnExport={handleClickStationExport}
                                    cardOver={props.cardOver}
                                    cardOut={props.cardOut}
                                    toggleScenarios={props.toggleScenariosLayer}
                                  />                                                 
                                }
                              },
                              /*render: rowData => 
                             <div className={classes.stationDeatilsBlock +" shadow-default list-item"} >
                                 {showExportPanel ?

                  
                                  <div  className={showExportPanel?'list-item-chbx': 'list-item-chbx-hide'}>
                                    {
                                      (rowData.station_type === 1 && (rowData.volume !== "" || rowData.class !== "" || rowData.speed !== ""))
                                      || (rowData.station_type === 2 && (rowData.bicycle !== "" || rowData.pedestrian !== "" || rowData.turning !== "")) ?
                                        <StyledCheckbox 
                                          value={rowData.station_id}
                                          checked={rowData.checked}
                                          onChange={(e) => selectOneStation(e, rowData.station_type, rowData.client_station_id, rowData.location)}
                                        />
                                        : null
                                    }
                                  </div>
                                  :
                                  null
                                  }
                                <div className={showExportPanel ?"name-card-chbx":"name-card"} style={showExportPanel ? {paddingLeft: '16px'} : {}}>
                                  
                                  <div  onClick={() =>{ props.getStationDetail(rowData.station_id); props.highlightStation(rowData.latitude, rowData.longitude, rowData.client_station_id, rowData.station_type)} } 
                                        onMouseOver={() => props.cardOver(rowData.latitude, rowData.longitude, rowData.client_station_id, rowData.station_type)} 
                                        onMouseOut={() => props.cardOut(rowData.latitude, rowData.longitude, rowData.client_station_id, rowData.station_type)}
                                        className={"data"}>
                                  
                                      <div>
                                      <NavLink to='#' style={{ textDecoration: 'none', color: '#3F3F46' }} >
                                      <span className={'station-id'}>{rowData.client_station_id}</span>{rowData.is_shared?<span className='lb-share-station'>Shared</span>:null} <br/> <span className={'station-direction'}>{rowData.location}</span> 
                                      </NavLink>

                                      </div>
                                    <ul style={{display: 'flex'}}>
                                    {rowData.station_type==2 ?
                                    rowData.turning == '' && rowData.pedestrian == '' && rowData.bicycle == '' ?
                                    
                                    null :
                                    <>
                                      {rowData.turning == '' ? null : <li className={'name-card-year-ul'}><img src={require('../../assets/icons/study/Turning Movement.png')}   />    <span  className={'panel-year'}>{rowData.turning}</span> </li>}
                                      {rowData.pedestrian == '' ? null : <li  className={'name-card-year-ul'}><img src={require('../../assets/icons/study/Walking.png')}   />   <span  className={'panel-year'}>{rowData.pedestrian}</span> </li>}
                                      {rowData.bicycle == '' ? null : <li  className={'name-card-year-ul'}><img src={require('../../assets/icons/study/Bike.png')}   />   <span className={'panel-year'}>{rowData.bicycle}</span> </li>}
                                    </>

                                  
                                    :
                                    rowData.volume == '' && rowData.class == '' && rowData.speed == '' ?
                                    null:
                                    <>
                                      {rowData.volume == '' ? null : <li className={'name-card-year-ul'}><img src={require('../../assets/icons/study/Chart - Bar.png')}   />   <span  className={'panel-year'}>{rowData.volume}</span> </li>
                                      }
                                      {rowData.class == '' ? null : <li className={'name-card-year-ul'}><img src={require('../../assets/icons/study/Truck.png')}   />   <span  className={'panel-year'}>{rowData.class}</span> </li>}
                                      {rowData.speed == '' ? null : <li className={'name-card-year-ul'}><img src={require('../../assets/icons/study/Speedo.png')}   />   <span  className={'panel-year'}>{rowData.speed}</span> </li>}
                                    </>
                                  
                                  }
                                    </ul>
                                  </div>
                                  <div className={"pin"}>                                      
                                      {rowData.station_type==2 ?
                                      <object data={rowData.is_shared?require('../../assets/icons/marker_Intersection_shared.svg'):require('../../assets/icons/marker_Intersection.svg')}  className={'station-img'}>   </object>
                                      :                                      
                                      <object data={rowData.is_shared?require('../../assets/icons/marker_Midblock_shared.svg'):require('../../assets/icons/marker_Midblock.svg')}   className={'station-img'}> </object>
                                      }
                                      </div>
                                </div>
                              </div>,*/
                              headerStyle: {
                                display: 'none',
                              }
                            }
                          ]}

                          data={resultData}
                          totalCount={resultData.length}
                          options={{
                            filtering: false,
                            sorting: false,
                            title: false,
                            paging: resultData.length > 0 ? true : false,
                            pageSize: pageSizeResult,
                            pageSizeOptions: [],
                            search: false,
                            emptyRowsWhenPaging: false,
                            header:false,
                          
                          }}
                          
                          localization={{
                            body: {
                              emptyDataSourceMessage: (
                                <></>
                              ),
                            },
                          }}
                        />
                      </div> 
                      </div>   
                    :
                    <div className={classes.loader}>
                      <CircularProgress />

                    </div>
                 
              }
        {
            showExportOpts &&
            <ClickAwayListener onClickAway={handleClickAway}>
                <div className={classes.exportOptsList} >
                    <ul>
                        <li onClick={handleExportSelect}><img src={require('../../assets/icons/file_download.svg')} /> <span>Select stations &amp; export</span></li>
                    </ul>
                </div>
            </ClickAwayListener>
        }
            
      </div>
    </React.Fragment>
  );
}

export default SearchResults;
//End SearchResults component code ...
